(function () {
    "use strict";

    var root = document.querySelector(".section__custom_feature_product");

    if (!root) {
      var gloProductEl = document.querySelector("[data-featured-product]");
      if (!gloProductEl) return;
      root = gloProductEl;
    }

    /* Scroll reveal */
    var revealEls = root.querySelectorAll(".reveal");
    if (revealEls.length && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add("in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add("in");
      });
    }
  
    /* Product qty + Ajax add to cart (cart-notification) */
    var productRoot = root.matches("[data-feature-product]")
      ? root
      : root.querySelector("[data-feature-product]");
    if (productRoot && !productRoot.hasAttribute("data-feature-product-initialized")) {
      productRoot.setAttribute("data-feature-product-initialized", "");

      var form = productRoot.querySelector(".product-form");
      var variantInput = productRoot.querySelector("[data-variant-id]");
      var qtyInput = productRoot.querySelector("[data-qty-input]");
      var minusBtn = productRoot.querySelector("[data-qty-minus]");
      var plusBtn = productRoot.querySelector("[data-qty-plus]");
      var addBtn = productRoot.querySelector("[data-add-to-cart]");
      var variantSelect = productRoot.querySelector("[data-variant-select]");
      var submitButton = form ? form.querySelector('button[type="submit"]') : null;
      var spinner = submitButton
        ? submitButton.querySelector(".loading-overlay__spinner")
        : null;
      var cartRoot =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
        "/";
      var productSection = document.getElementById("product");
      var cartNotificationPanel = document.getElementById("cart-notification");
      var shouldReturnToProductSection = false;

      function getQty() {
        return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      }

      function setQty(n) {
        if (qtyInput) qtyInput.value = String(Math.max(1, n));
        updatePrice();
      }

      function isAvailable() {
        if (variantSelect) {
          var opt = variantSelect.options[variantSelect.selectedIndex];
          return opt && opt.getAttribute("data-available") === "true";
        }
        return (
          variantInput && variantInput.getAttribute("data-available") === "true"
        );
      }

      function formatMoney(cents) {
        var format =
          (typeof window.afterpay_shop_money_format === "string" &&
            window.afterpay_shop_money_format) ||
          addBtn.getAttribute("data-money-format") ||
          "${{amount}}";
        var placeholder = /\{\{\s*(\w+)\s*\}\}/;

        function withDelimiters(number, precision, thousands, decimal) {
          if (isNaN(number) || number == null) return "0";
          number = (number / 100.0).toFixed(precision == null ? 2 : precision);
          var parts = number.split(".");
          var dollars = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + (thousands || ",")
          );
          return dollars + (parts[1] ? (decimal || ".") + parts[1] : "");
        }

        var match = format.match(placeholder);
        var formatType = match ? match[1] : "amount";
        var value;

        switch (formatType) {
          case "amount_no_decimals":
            value = withDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = withDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = withDelimiters(cents, 0, ".", ",");
            break;
          default:
            value = withDelimiters(cents, 2);
        }

        return format.replace(placeholder, value);
      }

      function updatePrice() {
        if (!addBtn) return;
        var labelEl = addBtn.querySelector("[data-add-label]");
        if (!labelEl) return;
        var soldOutLabel =
          addBtn.getAttribute("data-label-sold-out") || "Sold out";
        var available = isAvailable();

        addBtn.disabled = !available;

        if (!available) {
          labelEl.textContent = soldOutLabel;
          return;
        }

        var priceCents;
        if (variantSelect) {
          var opt = variantSelect.options[variantSelect.selectedIndex];
          if (!opt) return;
          priceCents = parseInt(opt.getAttribute("data-price"), 10);
          if (variantInput) {
            variantInput.value = opt.value;
            variantInput.setAttribute("data-price", opt.getAttribute("data-price"));
            variantInput.setAttribute(
              "data-available",
              opt.getAttribute("data-available")
            );
          }
        } else if (variantInput) {
          priceCents = parseInt(variantInput.getAttribute("data-price"), 10);
        }

        if (!isNaN(priceCents)) {
          var totalCents = priceCents * getQty();
          var label = addBtn.getAttribute("data-label-default") || "Add to cart";
          labelEl.textContent =
            label + " — " + formatMoney(totalCents);
        }
      }

      if (minusBtn) {
        minusBtn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setQty(getQty() - 1);
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setQty(getQty() + 1);
        });
      }
      if (qtyInput) {
        qtyInput.addEventListener("change", function () {
          setQty(getQty());
        });
      }

      if (variantSelect && variantInput) {
        variantSelect.addEventListener("change", function () {
          variantInput.value = variantSelect.value;
          updatePrice();
        });
      }

      if (
        cartNotificationPanel &&
        productSection &&
        !cartNotificationPanel.hasAttribute("data-feature-product-return-observer")
      ) {
        var notificationObserver = new MutationObserver(function () {
          if (
            shouldReturnToProductSection &&
            !cartNotificationPanel.classList.contains("active")
          ) {
            requestAnimationFrame(function () {
              productSection.scrollIntoView({ behavior: "smooth", block: "start" });
            });
            shouldReturnToProductSection = false;
          }
        });
        notificationObserver.observe(cartNotificationPanel, {
          attributes: true,
          attributeFilter: ["class"],
        });
        cartNotificationPanel.setAttribute(
          "data-feature-product-return-observer",
          "true"
        );
      }

      if (form && submitButton && variantInput) {
        form.addEventListener("submit", function (event) {
          event.preventDefault();
          if (submitButton.disabled) return;

          var cartComponent = document.querySelector(
            "cart-notification, cart-drawer"
          );

          submitButton.disabled = true;
          submitButton.classList.add("loading");
          if (spinner) spinner.classList.remove("hidden");

          var formData = new FormData(form);
          if (
            cartComponent &&
            typeof cartComponent.getSectionsToRender === "function"
          ) {
            formData.append(
              "sections",
              cartComponent
                .getSectionsToRender()
                .map(function (section) {
                  return section.id;
                })
                .join(",")
            );
            formData.append("sections_url", window.location.pathname);
            if (typeof cartComponent.setActiveElement === "function") {
              cartComponent.setActiveElement(document.activeElement);
            }
          }

          fetch(cartRoot + "cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: formData,
          })
            .then(function (res) {
              return res.json().then(function (json) {
                return { ok: res.ok, json: json };
              });
            })
            .then(function (result) {
              if (!result.ok || result.json.status) {
                throw new Error("Add to cart failed");
              }
              if (
                cartComponent &&
                typeof cartComponent.renderContents === "function"
              ) {
                cartComponent.renderContents(result.json);
                if (
                  cartComponent.tagName &&
                  cartComponent.tagName.toLowerCase() === "cart-notification"
                ) {
                  shouldReturnToProductSection = true;
                }
              } else {
                window.location.href = cartRoot + "cart";
              }
            })
            .catch(function () {
              /* reset button in finally */
            })
            .finally(function () {
              submitButton.classList.remove("loading");
              if (spinner) spinner.classList.add("hidden");
              updatePrice();
            });
        });

        updatePrice();
      }
    }
  })();
  